import React from 'react';

function StatusCheck() {
  return (
    <div />
  );
}

export default StatusCheck;
